import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=30e28328&"
import script from "./Todos.vue?vue&type=script&lang=ts&"
export * from "./Todos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports